var n={NUMBER_0:0,NUMBER_1:1,NUMBER_2:2};function r(n){return t(n)}function t(n,r){return n}function u(n){return n}export{n as SortOrder,r as SortOrderFromJSON,t as SortOrderFromJSONTyped,u as SortOrderToJSON};
